import { render } from "./MainHeader.vue?vue&type=template&id=adca1f42"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"

import "./MainHeader.vue?vue&type=style&index=0&id=adca1f42&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__